import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { serverUrl } from "../utils/Constants";
import "../styles/ourProducts.css";
// import Testimonials from "../testimonial.json";

export default function OurProducts() {
  const [loading, setLoading] = useState(true);
  const [testimonials, setTestimonials] = useState([]);
  const navigate = useNavigate();
  const icons = ["guidance:walker", "mdi:chair", "healthicons:crutches"];

  useEffect(() => {
    try {
      axios.get(`${serverUrl}/get-testimonials.php`).then((response) => {
        setTestimonials(response.data);
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching products:", error);
      setLoading(false);
    }
  }, []);

  const openProductsPage = () => {
    const activeTab = document.querySelector("#products-tab.active");
    if (activeTab) {
      const hashName = activeTab.getAttribute("href").substring(1); // Get the tab's hash
      navigate(`/products/${hashName}`);
    }
  };

  const renderProduct = (imgSrc, code, description) => (
    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
      <div className="product-box">
        <div className="product-img-wrap">
          <img src={imgSrc} className="img-fluid" alt={code} />
        </div>
        <div className="product-text-wrap">
          {code}
          <br />
          {description}
        </div>
      </div>
    </div>
  );

  const renderTestimonials = () => {
    if (loading) {
      return <p className="text-center fs-4">Loading...</p>;
    }

    return testimonials.map((testimonial, index) => (
      <div key={index} className={`carousel-item testimonial-item ${index === 0 ? "active" : ""}`}>
        <div className="testimonial">
          <p className="text-content">{testimonial.desc}</p>
          <p className="text-content" style={{ paddingTop: "20px" }}>
            <span style={{ float: "left", width: "50%", color: "#0dc0c0", fontSize: "16px" }}>
              <b>{testimonial.name}</b>
            </span>
            <span style={{ float: "right", width: "50%", fontSize: "16px" }}>{testimonial.place}</span>
          </p>
        </div>
      </div>
    ));
  };

  return (
    <>
      <section style={{ textAlign: "center" }}>
        <h2 className="products-title">Our Featured Products</h2>
        <div className="ourproducts-parent-container">
          <div className="container ourproducts-wrapper" style={{ marginTop: "-5.1rem" }}>
            <ul className="nav nav-tabs row column-gap-0" id="myTab" role="tablist">
              {["Walkers", "Commode Stool & Chairs", "Walking Sticks & Crutches"].map((label, index) => (
                <li key={index} className="ourproducts-nav-item col-lg-4 col-md-4">
                  <a
                    className={`nav-link py-4 ${index === 0 ? "active" : ""}`}
                    id="products-tab"
                    data-bs-toggle="tab"
                    href={`#${label.toLowerCase().replace(/ & | /g, "-")}`}
                    role="tab"
                    aria-controls={label.toLowerCase().replace(/ & | /g, "-")}
                    aria-selected={index === 0}
                  >
                    <iconify-icon
                      icon={icons[index]}
                      style={{ fontSize: "20px", marginRight: "8px", position: "relative", top: "3px" }}
                    ></iconify-icon>
                    {label}
                  </a>
                </li>
              ))}
            </ul>

            <div>
              <div className="tab-content">
                <div className="tab-pane fade show active pt-3" id="walkers" role="tabpanel" aria-labelledby="walkers-tab">
                  <div className="row g-2">
                    {renderProduct("/images/products/Rehab Adj. Folding Walker – 1H.png", "WLK - 1H", "Pack of - 10 Pcs")}
                    {renderProduct("/images/products/Rehab Adj. Folding Walker – 2H.png", "WLK - 2H", "Pack of - 10 Pcs")}
                    {renderProduct("/images/products/Rehab Adj. Folding Walker – 2H Copper.png", "WLK - 2H (Copper)", "Pack of - 10 Pcs")}
                    {renderProduct("/images/products/Rehab Adj. Folding Walker 2H – Dx.png", "WLK - 2H (Dx.)", "Pack of - 10 Pcs")}
                  </div>
                </div>
                <div className="tab-pane fade show p-3" id="commode-stool-chairs" role="tabpanel" aria-labelledby="commodes-tab">
                  <div className="row g-2">
                    {renderProduct("/images/products/Rehab Folding Commode Chair – Parda.png", "WCMD - Chair (H) Parda", "Pack of - 8 Pcs")}
                    {renderProduct("/images/products/Rehab Folding Commode Chair – (H).png", "CMD - Chair (H) Pwd. Coated", "Pack of - 8 Pcs")}
                    {renderProduct("/images/products/Rehab Folding Commode Chair – Chrome (H).png", "CMD - Chair (H) Chrome", "Pack of - 8 Pcs")}
                    {renderProduct("/images/products/Rehab Folding Commode – Potty Ord.png", "CMD - Potty (Ord.)", "Pack of - 20 Pcs")}
                  </div>
                </div>
                <div className="tab-pane fade show p-3" id="walking-sticks-crutches" role="tabpanel" aria-labelledby="commodes-tab">
                  <div className="row g-2">
                    {renderProduct(
                      "/images/products/Rehab Adjustable Arm Crutches - Ord.png",
                      "WKA - Arm Crutches (Ord.) (6/7 soot)",
                      "Pack of 10 pairs"
                    )}
                    {renderProduct(
                      "/images/products/Rehab Adjustable Arm Crutches – Dx.png",
                      "WKA - Arm Crutches (Dx.) (8 soot - 1)",
                      " Pack of 10 pairs"
                    )}
                    {renderProduct("/images/products/Rehab Adjustable Elbow Stick – Ord. & Dx.2.png", "WKA - Elbow Stick (Dx.)", "Pack of - 20 Pcs")}
                    {renderProduct("/images/products/Rehab Adjustable Quadripod.png", "WKA - Quadripod", "Pack of - 40 Pcs")}
                  </div>
                </div>
              </div>
              <button onClick={openProductsPage} className="button seemore-products-btn">
                See More
              </button>
            </div>
          </div>
        </div>
      </section>

      <section id="testimonials">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <h2 className="testimonialTitle">
                Clients <b>Testimonials</b>
              </h2>
              <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner carousel-testimonial">{renderTestimonials()}</div>
                <button className="carousel-control-prev buttons" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                </button>
                <button className="carousel-control-next buttons" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
